import React from "react";
import SEO from "../components/seo/SEO";
import Navigation from "../components/landing/Navigation";
import Hero from "../components/landing/Hero";
import Services from "../components/landing/Services";
import WhyUs from "../components/landing/WhyUs";
import Gallery from "../components/landing/Gallery";
import Testimonials from "../components/landing/Testimonials";
import CTASection from "../components/landing/CTASection";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";

const LOCAL_BUSINESS_LD = {
    "@context": "https://schema.org",
    "@graph": [
        {
            "@type": "Organization",
            "@id": "https://kbmusic.sk/#organization",
            "name": "KB MUSIC",
            "url": "https://kbmusic.sk",
            "logo": {
                "@type": "ImageObject",
                "url": "https://kbmusic.sk/logo-kb.png",
                "width": 512,
                "height": 512,
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "customer service",
                "email": "info@kbmusic.sk",
                "availableLanguage": ["Slovak", "Czech"],
            },
            "areaServed": { "@type": "Country", "name": "Slovensko" },
            "sameAs": [
                "https://www.facebook.com/kbmusicsk",
            ],
        },
        {
            "@type": "LocalBusiness",
            "@id": "https://kbmusic.sk",
            "name": "KB MUSIC",
            "description": "Profesionálne ozvučenie, osvetlenie a technická produkcia eventov na Slovensku. Špičková technika L-Acoustics, d&b, Robe, Martin.",
            "url": "https://kbmusic.sk",
            "email": "info@kbmusic.sk",
            "image": "https://kbmusic.sk/logo-kb.png",
            "logo": "https://kbmusic.sk/logo-kb.png",
            "priceRange": "$$",
            "currenciesAccepted": "EUR",
            "paymentAccepted": "Invoice",
            "areaServed": { "@type": "Country", "name": "Slovensko" },
            "parentOrganization": { "@id": "https://kbmusic.sk/#organization" },
            "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Služby KB MUSIC",
                "itemListElement": [
                    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Ozvučenie eventov", "url": "https://kbmusic.sk/sluzby/ozvucenie" } },
                    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Osvetlenie pódií", "url": "https://kbmusic.sk/sluzby/osvetlenie" } },
                    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "LED obrazovky a projekcia", "url": "https://kbmusic.sk/sluzby/led" } },
                    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Prenájom profesionálnej techniky", "url": "https://kbmusic.sk/prenajom" } },
                    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Podia, strechy a ground supporty", "url": "https://kbmusic.sk/sluzby/produkcia" } },
                    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Kamerový prenos a video processing (Blackmagic)", "url": "https://kbmusic.sk/sluzby/kompletne" } },
                ],
            },
        },
        {
            "@type": "WebSite",
            "@id": "https://kbmusic.sk/#website",
            "url": "https://kbmusic.sk",
            "name": "KB MUSIC",
            "description": "Profesionálne ozvučenie, osvetlenie a technická produkcia eventov na Slovensku.",
            "publisher": { "@id": "https://kbmusic.sk/#organization" },
            "inLanguage": "sk-SK",
        },
    ],
};

export default function LandingPage() {
    return (
        <main className="relative bg-nova-black text-white overflow-hidden" data-testid="landing-page">
            <SEO
                description="Kompletná technická produkcia eventov na Slovensku. Ozvučenie, osvetlenie, LED systémy pre koncerty, svadby, firemné eventy a festivaly. 20+ rokov skúseností."
                keywords="ozvučenie eventov, osvetlenie pódií, technická produkcia, LED obrazovky, prenájom techniky, KB MUSIC, Slovensko, svadba, koncert, firemný event"
                canonical="/"
                jsonLd={LOCAL_BUSINESS_LD}
            />
            <Navigation />
            <Hero />
            <Services />
            <WhyUs />
            <Gallery />
            <Testimonials />
            <CTASection />
            <Contact />
            <Footer />
        </main>
    );
}
